export default "__VITE_ASSET__BIOB46ql__"